
export const ConditionalWrapper = ({ when, wrapper, children }) => 
  when ? wrapper(children) : children;

export const Wrapper = ({ condition, when, otherwise, children }) => 
  condition ? when(children) : otherwise(children);

  